<template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div SID1014">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
              <!--SID1014 Body Part -->
							<template>
								<el-container class="SID1014__UserRegistration">
									<div class="SID1014__Container">
									<!-- Breadcrumb section -->
									<el-breadcrumb separator-class="el-icon-arrow-right">
										<el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
										<el-breadcrumb-item :to="{ path: '1013' }">ユーザー一覧</el-breadcrumb-item>
										<el-breadcrumb-item :to="{ path: '' }">ユーザー登録</el-breadcrumb-item>
									</el-breadcrumb>
										<div class="FormDiv">
											<el-form ref="ruleForm"  :rules="rules" :model="ruleForm" class="div-form" label-width="auto">
													
												<el-form-item label="所属ユーザーグループ" prop="region">
													<el-select v-model="ruleForm.region" id="selected_id" @change="handleChange($event)" placeholder="">
													<el-option
														v-for="item in getdropdownResult1014"
														:key="item.user_group_id"
														:label="item.user_group_name"
														:value="item.user_group_id">
														</el-option>
													</el-select>
												</el-form-item>
													<el-form-item prop="UserId" label="ユーザーID" v-if="this.UserIdDisable == 1" >
														<el-input  v-model="ruleForm.UserId" :disabled="UserIdDisable == 1"></el-input>
													</el-form-item> 
													<el-form-item prop="UserId" label="ユーザーID" v-else>
														<el-input  v-model="ruleForm.UserId"></el-input>
													</el-form-item>  
													<el-form-item label="パスワード" prop="password" v-if="this.$route.params.Details == undefined ||this.$route.params.Details == '' ">
														<el-input type="password" v-model="ruleForm.password"></el-input>
													</el-form-item>
													<el-form-item label="パスワード(変更時のみ入力)" prop="password1" v-else>
														<el-input type="password" v-model="ruleForm.password1"></el-input>
													</el-form-item>
													<el-form-item label="パスワード（確認）" prop="ConfirmPassword" v-if="this.$route.params.Details == undefined|| this.$route.params.Details == ''">
														<el-input  type="password" v-model="ruleForm.ConfirmPassword"></el-input>
													</el-form-item>
													<el-form-item label="パスワード（確認）" prop="ConfirmPassword1" v-else>
														<el-input  type="password" v-model="ruleForm.ConfirmPassword1"></el-input>
													</el-form-item>
													<el-form-item label="ユーザー名" prop="UserName">
														<el-input v-model="ruleForm.UserName"></el-input>
													</el-form-item>
													<el-form-item prop="MailAddress" label="メールアドレス">
														<el-input v-model="ruleForm.MailAddress"></el-input>
													</el-form-item>
													<el-form-item label="ログイン時にIP制限を適用する" class="label__mandate">
														<el-switch v-model="ruleForm.value1" class="inputSwitch"></el-switch>
													</el-form-item>
													<el-form-item label="このユーザを管理者とする" class="label__mandate2" v-if="showtitle == 1">
														<el-switch v-model="ruleForm.value2" disabled class="inputSwitch"></el-switch>
													</el-form-item>
													<el-form-item label="このユーザを管理者とする" class="label__mandate2" v-else>
														<el-switch v-model="ruleForm.value2"  class="inputSwitch"></el-switch>
													</el-form-item>
													<el-form-item label="このユーザはトピックスを作成できる" class="label__mandate3">
														<el-switch v-model="ruleForm.value3" class="inputSwitch"></el-switch>
													</el-form-item>
													<el-form-item label="このユーザはパスワードを変更できる" class="label__mandate4">
														<el-switch v-model="ruleForm.value4" class="inputSwitch"></el-switch>
													</el-form-item>
													<!-- 2026/06/15  生成AI連携商用版対応  START -->
													<el-form-item label="このユーザはAIサービスを利用できる" class="label__mandate5">
														<div class="ai-service-usage-content">
															<div class="ai-service-usage-row">
																<el-switch
																	v-model="ruleForm.value6"
																	class="inputSwitch ai-service-usage-switch"
																	:disabled="!canEnableAiService && !ruleForm.value6"
																></el-switch>
																<span v-if="aiServiceUsageLoaded" class="ai-service-usage-info">
																	利用中：<strong>{{ aiServiceConfiguredCount }}</strong>名 / 上限：<strong>{{ aiServiceUsage }}</strong>名
																</span>
															</div>
															<span
																v-if="aiServiceUsageLoaded && !canEnableAiService && !ruleForm.value6"
																class="ai-service-usage-info__notice"
															>
																※AIサービス利用人数が上限に達しているため、設定できません。
															</span>
														</div>
													</el-form-item>
													<!-- 2026/06/15  生成AI連携商用版対応  END -->
													<el-form-item v-if="is_MC_User_Authority" label="ユーザー表示権限(MC)" prop="groupvalue" >
														<el-select v-model="ruleForm.groupvalue"  class="inputGroupSelect" placeholder="Select">
															<el-option
															v-for="item in groupoptions"
															:key="item.value"
															:label="item.label"
															:value="item.value">
															</el-option>
														</el-select>
													</el-form-item>
													<el-form-item v-else label="ユーザー表示権限(MC)" prop="groupvalue_nonreq" >
														<el-select v-model="ruleForm.groupvalue_nonreq"  class="inputGroupSelect" placeholder="Select" :disabled="is_MC_User_Authority == false">
															<el-option
															v-for="item in groupoptions"
															:key="item.value"
															:label="item.label"
															:value="item.value">
															</el-option>
														</el-select>
													</el-form-item>
													<el-form-item v-if="is_SC_User_Authority" label="ユーザー表示権限(SC)" prop="usagevalue">
														<el-select v-model="ruleForm.usagevalue"  placeholder="Select" >
															<el-option
															v-for="items in usageoptions"
															:key="items.value"
															:label="items.label"
															:value="items.value">
															</el-option>
														</el-select>
													</el-form-item> 
													<el-form-item v-else label="ユーザー表示権限(SC)" prop="usagevalue_nonreq">
														<el-select v-model="ruleForm.usagevalue_nonreq"  placeholder="Select" :disabled="is_SC_User_Authority == false">
															<el-option
															v-for="items in usageoptions"
															:key="items.value"
															:label="items.label"
															:value="items.value">
															</el-option>
														</el-select>
													</el-form-item>
													<el-form-item label="SCユーザーID" prop="NikkiUserName">
														<el-input v-model="ruleForm.NikkiUserName"></el-input>
													</el-form-item>
													<el-form-item label="SCパスワード" prop="NikkiPassword">
														<el-input type="password" v-model="ruleForm.NikkiPassword"></el-input>
													</el-form-item>	
													<el-form-item label="このユーザを利用停止とする">
														<el-switch v-model="ruleForm.value5" class="inputSwitch"></el-switch>
													</el-form-item>												   
													<el-form-item label="">
														<el-button @click="submitForm('ruleForm')" type="primary" plain>登録</el-button>
														<el-button @click="gotoback()" type="info" plain class="buttonleftmove_css">戻る</el-button>	
													</el-form-item>          
												</el-form>            
										</div> 
									<el-row class="button_css">
										
									</el-row>
									</div>
								</el-container>
							</template>
              <!--SID1014 Body Part End-->
						</pane>
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>
			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from '../../router';
import json from '../../components/config.json';
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
export default {
	name: "app",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
		
		
		var checkPass = (Rules, value, callback) => {
				
		var passw= this.ruleForm.password;
			if (value != passw) {
				callback(new Error('パスポートに1つ数字と1つ特殊文字を入力してください。'));
			} 
			else

				{
				callback();
			}
	};
	var checkPass1 = (Rules, value, callback) => {
				
		var passw= this.ruleForm.password1;
			if (value != passw) {
				callback(new Error('パスポートに1つ数字と1つ特殊文字を入力してください。'));
			} 
			else

				{
				callback();
			}
	};

	var confirmEmail = (rules, value, callback) => {
		var sympattern= /^[a-zA-Z0-9@._+-]+$/
		var regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
		var chksym= value;
		if(regex.test(chksym)){
			callback(new Error("メールアドレスは半角英数字を入力してください。"));
		}
	else if (!chksym.match(sympattern)) {
				
					callback(new Error('メールアドレスに使用できない文字が含まれています。'));
				}else{
				callback();
			}
	};

	return {
		region: null,
		showtitle: '',
			ruleForm: {
				
				UserId: '',
				password: '',
				ConfirmPassword: '',
				password1: '',
				ConfirmPassword1: '',
				UserName: '',
				MailAddress: '',
				NikkiUserName: '',
				region:'',
				groupvalue: '',
				usagevalue: '',
				groupvalue_nonreq: '',
				usagevalue_nonreq: '',
				NikkiPassword:'',
				value1: false,
				value2: false,
				value3: false,
				value4: true,
				value5: false,			
				// 2026/06/15  生成AI連携商用版対応  START
				value6: false,	
				// 2026/06/15  生成AI連携商用版対応  END
				
			},
			UserIdDisable:'0',
			rules: {
				/*
				* Backlog issue related fix
				* Author: BM
				* Backlog Id: BT08460_EXTERNAL-1652
				* The error text should not display when you enter it.
				* UserID, password, SC UserID, SC password with a symbol  
				*/
			password: [
				{required: true,  message: 'パスワードを入力してください。'},
				{ max: 256, message: 'パスワードは256文字以下を入力してください。'},
				{ pattern: /^[\uffe5a-zA-Z0-9-!$%^&*()_+|~=`{}[\]:";'<>?,.@#/]+$/, message: 'パスワードに使用できない文字が含まれています。'},
				
				
			],
			ConfirmPassword: [
					{ required: true, message: 'パスワード(確認)を入力してください。', trigger: 'blur' },
					{validator: checkPass , message: 'パスワードが一致しないので、再入力してください。', trigger: 'blur'}
			],
			password1: [
				{ max: 256, message: 'パスワード（変更時のみ登録）は256文字以下を入力してください。'},
				{ pattern: /^[a-zA-Z0-9-!$%^&*()_+|~=`{}[\]:";'<>?,.@#/]+$/, message: 'パスワード（変更時のみ登録）に使用できない文字が含まれています。'},
				
				
			],
			ConfirmPassword1: [
					{validator: checkPass1 , message: 'パスワードが一致しないので、再入力してください。', trigger: 'blur'}
			],
			UserId: [
			{ required: true,type:"string", message: 'ユーザーIDを入力してください。'},
			{ max: 256, message: 'ユーザーIDは256文字以下を入力してください。'},
			{pattern: /^[+\u3040-\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9f\uffe5a-zA-Z0-9-!$%^&*()_+|~=`{}[\]:";'<>?,.@#/]+$/, message: 'ユーザーIDに使用できない文字が含まれています。'},

			],
			MailAddress: [
				{ required: true, message: 'メールアドレスを入力してください。' },  
				{max: 256, message: 'メールアドレスは256文字以下を入力してください。'},
				{ validator: confirmEmail,trigger: "blur"},
				{ type: 'email', message: 'メールアドレスを正しく入力してください。', trigger: 'blur'}
			],
			UserName: [
				{max: 256, message: 'ユーザー名は256文字以下を入力してください。'}          
			],
			NikkiUserName: [
				{max:17,message:'SCユーザーIDは17文字以下を入力してください。',trigger:'blur'},
				{pattern: /^[+\uffe5a-zA-Z0-9-!$%^&*()_+|~=`{}[\]:";'<>?,.@#/]+$/, message: 'SCユーザーIDは半角英数字を入力してください。'},          
			],
			NikkiPassword: [
				{max:17,message:'SCパスワードは17文字以下を入力してください。',trigger:'blur'},
				{pattern: /^[+\uffe5a-zA-Z0-9-!$%^&*()_+|~=`{}[\]:";'<>?,.@#/]+$/, message: 'SCパスワードは半角英数字を入力してください。'},
			],
			region: [
				{ required: true, message: '所属ユーザーグループを選択してください。', trigger: 'change' }
			],
			groupvalue: [
				{ required: true, message: 'MC契約がある場合はユーザー表示権限(MC)を選択してください。', trigger: 'change' }
			],
			usagevalue: [
				{ required: true, message: 'SC契約がある場合はユーザー表示権限(SC)を選択してください。', trigger: 'change' }
			]
			},
			groupname:"テストグループ",
			groupid:"testgroup",
			requestid:"testID",
			mctextusagelimit:"12345678",
			sctextusagelimit:"1234",
			options: [],
			select_option_keyvalue : '',
			usageoptions: [{
				value: 2,
				label: 'テキストのみ'
			}, {
				value: 3,
				label: 'テキスト&原文表示のみ'
			}, {
				value: 5,
				label: 'テキスト&原文表示・印刷'
			}],
			
			groupoptions: [{
				value: 1,
				// 2022/09/14  No17.ユーザー管理者機能の項目表記の改善  START
				//label: 'HDS',
				label: 'サムネイルのみ',
				// 2022/09/14  No17.ユーザー管理者機能の項目表記の改善  END
			},{
				value: 2,
				// 2022/09/14  No17.ユーザー管理者機能の項目表記の改善  START
				//label: 'ViewLight',
				label: 'サムネイル&原文表示のみ',
				// 2022/09/14  No17.ユーザー管理者機能の項目表記の改善  END
			},{
				value: 3,
				// 2022/09/14  No17.ユーザー管理者機能の項目表記の改善  START
				//label: '+View'
				label: 'サムネイル&原文表示・印刷',
				// 2022/09/14  No17.ユーザー管理者機能の項目表記の改善  END
			}],
			contract_id : '',
			user_id: '',
			is_MC_User_Authority: false,
			is_SC_User_Authority: false,
			// 2026/06/15  生成AI連携商用版対応  START
			aiServiceUsageLoaded: false,
			aiServiceUsage: 0,
			aiServiceConfiguredCount: 0,
			initialAiServiceFlag: false,
			isEdit: false,
			// 2026/06/15  生成AI連携商用版対応  END
		};
	},
	computed: {

		...mapGetters("situation1014", [
		
		"getuserid1014",
		"getresultusername1014", 
		"getusergroupid1014", 
		"getemail1014",          
		"getiprestictionflag1014",            
		"getloginflag1014",            
		"gettopiccreationflag1014",          
		"getpasswordchange1014",            
		// 2026/06/15  生成AI連携商用版対応  START
		"getaiserviceflag1014",
		// 2026/06/15  生成AI連携商用版対応  END
		"getmcuser1014",            
		"getscuser1014",         
		"getscuserid1014",        
		"getscusepassword1014",
		"getdropdownResult1014",
		"getresultResponse1014",
		"getuser_authority1014",
		"getmsgCode",
		"getEditMsgStatus"       

		]),
		...mapGetters("situation0001", [
			"getUserId",
			"getContractId",
			"getServiceLinkageInfo",
		]),
		// 2026/06/15  生成AI連携商用版対応  START
		effectiveAiServiceAvailableCount() {
			let available = Math.max(0, this.aiServiceUsage - this.aiServiceConfiguredCount);
			if (this.isEdit && this.initialAiServiceFlag && !this.ruleForm.value6) {
				available += 1;
			}
			return available;
		},
		canEnableAiService() {
			return this.effectiveAiServiceAvailableCount > 0 || this.ruleForm.value6;
		}
		// 2026/06/15  生成AI連携商用版対応  END
	},
	methods: {
		onSubmit() {
			this.$notify({
				title: json["1014_register_success_title"],
				message: json["1014_register_success_message"],
				type: 'success'           
			});
		},
		// 2026/06/15  生成AI連携商用版対応  START
		loadAiServiceUsageInfo() {
			this.$store.dispatch('communication1014/getAiServiceUsageInfo').then((resp) => {
				const data = resp && resp.data && resp.data.response && resp.data.response.data;
				if (data) {
					this.aiServiceUsage = data.ai_service_usage || 0;
					this.aiServiceConfiguredCount = data.ai_service_configured_count || 0;
					this.aiServiceUsageLoaded = true;
				}
			}).catch(() => {
				this.aiServiceUsageLoaded = false;
			});
		},
		// 2026/06/15  生成AI連携商用版対応  END
		gotoback(){
			this.$LogButtonEvent("1014","Return");
			this.$LogMethodIN("1014","gotoback");
						router.push({name:"UserGroupList"});
						this.$LogMethodOut("1014","gotoback");
					},
					onChange() {
					// alert(value);
					},
					handleChange($event){
			this.$LogButtonEvent("1014","ChangeMemberUser");
			this.$LogMethodIN("1014","handleChange");
			for(var i=0; i<this.getdropdownResult1014.length;i++){
				if($event == this.getdropdownResult1014[i].value){
					this.select_option_keyvalue = this.getdropdownResult1014[i]["user_group_id"];
				}
			}
			this.$LogMethodOut("1014","handleChange");
		},
		submitForm(formName) {
		this.$LogButtonEvent("1014","Register");
		this.$LogMethodIN("1014","submitForm");
		this.$refs[formName].validate((valid) => {
			if (valid) {
			
			
		
		if(this.isEdit == true){

			var user_auth_edit;
			if(this.ruleForm.value2){
				user_auth_edit=1
			}else{
				user_auth_edit=0
			}
			
			var Editusername;
			if(this.ruleForm.UserName ==""){
				Editusername=this.ruleForm.UserId;
			}else{
				Editusername=this.ruleForm.UserName;
			}
			var pass_change_stop_flag_edit;
			if(this.ruleForm.value4 == true)
			{
				pass_change_stop_flag_edit = false;
			}
			else
			{
				pass_change_stop_flag_edit = true;
			}

			var mc_user_authority_val = 0;
			if( this.ruleForm.groupvalue != "" || this.ruleForm.groupvalue_nonreq != ""){
				mc_user_authority_val  = this.is_MC_User_Authority == true ? this.ruleForm.groupvalue : this.ruleForm.groupvalue_nonreq;
			}
			var sc_user_authority_val = 0;
			if( this.ruleForm.usagevalue != "" || this.ruleForm.usagevalue_nonreq != ""){
				sc_user_authority_val  = this.is_SC_User_Authority == true ? this.ruleForm.usagevalue : this.ruleForm.usagevalue_nonreq;
			}
			var EditFormDetails = {
				"user_group_id":this.ruleForm.region,
				"user_id":this.ruleForm.UserId,
				"contract_id":this.contract_id,
				"password1": this.ruleForm.password1,
				"password2": this.ruleForm.ConfirmPassword1,
				"name": Editusername,
				"email": this.ruleForm.MailAddress,
				"Ip_restriction_flag":this.ruleForm.value1,
				"user_authority":user_auth_edit,
				"topics_creation_flag":this.ruleForm.value3,
				"pass_change_stop_flag":pass_change_stop_flag_edit,
				"mc_user_authority":mc_user_authority_val,
				"sc_user_authority": sc_user_authority_val,
				"sc_user_id": this.ruleForm.NikkiUserName,
				"sc_user_pw": this.ruleForm.NikkiPassword,
				"login_stop_flag":this.ruleForm.value5,
				// 2026/06/15  生成AI連携商用版対応  START
				"use_ai_service_flag":this.ruleForm.value6,
				// 2026/06/15  生成AI連携商用版対応  END
				"process_kbn":2

			};
			this.$store.dispatch('communication1014/EditFormData',EditFormDetails).then(()=>{
				if(this.getEditMsgStatus == 0){
					
					this.$alert(this.getresultResponse1014,"確認", {
				confirmButtonText: 'OK',
				}).then(()=>{
					router.push("/1013")
					});

				}
				else{
					this.$alert(this.getresultResponse1014,"確認", {
				confirmButtonText: 'OK',
				}).then(()=>{
					
					});

				}
				
			});
				
				
		}
		else{
			var user_auth;
			if(this.ruleForm.value2){
				user_auth=1
			}else{
				user_auth=0
			}
			var username;
			if(this.ruleForm.UserName ==""){
				username=this.ruleForm.UserId;
			}else{
				username=this.ruleForm.UserName;
			}
			var pass_change_stop_flag_add;
			if(this.ruleForm.value4 == true)
			{
				pass_change_stop_flag_add = false;
			}
			else
			{
				pass_change_stop_flag_add = true;
			}

			mc_user_authority_val = 0;
			if( this.ruleForm.groupvalue != "" || this.ruleForm.groupvalue_nonreq != ""){
				mc_user_authority_val  = this.is_MC_User_Authority == true ? this.ruleForm.groupvalue : this.ruleForm.groupvalue_nonreq;
			}
			sc_user_authority_val = 0;
			if( this.ruleForm.usagevalue != "" || this.ruleForm.usagevalue_nonreq != ""){
				sc_user_authority_val  = this.is_SC_User_Authority == true ? this.ruleForm.usagevalue : this.ruleForm.usagevalue_nonreq;
			}

			var AddFormDetails = {
				"user_group_id":this.ruleForm.region,
				"user_id":this.ruleForm.UserId,
				"contract_id":this.contract_id,
				"password1": this.ruleForm.password,
				"password2": this.ruleForm.ConfirmPassword,
				"name": username,
				"email": this.ruleForm.MailAddress,
				"Ip_restriction_flag":this.ruleForm.value1,
				"user_authority":user_auth,
				"topics_creation_flag":this.ruleForm.value3,
				"pass_change_stop_flag":pass_change_stop_flag_add,
				"mc_user_authority": mc_user_authority_val,
				"sc_user_authority": sc_user_authority_val,
				"sc_user_id": this.ruleForm.NikkiUserName,
				"sc_user_pw": this.ruleForm.NikkiPassword,
				"login_stop_flag":this.ruleForm.value5,
				// 2026/06/15  生成AI連携商用版対応  START
				"use_ai_service_flag":this.ruleForm.value6,
				// 2026/06/15  生成AI連携商用版対応  END
				"process_kbn":1

			};
			
			this.$store.dispatch('communication1014/EditFormData',AddFormDetails).then(()=>{
				if(this.getEditMsgStatus == 0){
					
					this.$alert(this.getresultResponse1014,"確認", {
				confirmButtonText: 'OK',
				}).then(()=>{
					router.push("/1013")
					});

				}
				else{
					this.$alert(this.getresultResponse1014,"確認", {
				confirmButtonText: 'OK',
				}).then(()=>{
					
					});

				}
			});
			
		}
		
		
		
		} else {
		return false;
		}
		});
		this.$LogMethodOut("1014","submitForm");
	},
		
	},


	created : function(){
			
		
		if(this.$route.params.Details)
		{
			var user_group_id = this.$route.params.Details.user_group_id;
			var user_id = this.$route.params.Details.user_id;

			var is_edit = this.$route.params.Details.isEdit;
			this.isEdit = is_edit;

			const Params_For_AID0039 = {
				user_group_id : user_group_id,
				user_id: user_id
			};
			this.$store.dispatch('communication1014/Get_From_AID0039', Params_For_AID0039).then(() => {
				var user_idGet=this.user_id;
				if(user_idGet== this.getuserid1014){
					this.showtitle = 1;
					this.ruleForm.value2=this.getuser_authority1014;
				}else{
					this.ruleForm.value2=this.getuser_authority1014;
					this.showtitle =0;
				}
				this.UserIdDisable = '1';
				this.selected=this.getresultusername1014;
				this.ruleForm.UserId= this.getuserid1014;
				this.ruleForm.UserName = this.getresultusername1014;   
				this.ruleForm.region = this.getusergroupid1014; 
				this.ruleForm.MailAddress = this.getemail1014;
				this.ruleForm.value1 = this.getiprestictionflag1014;            
				this.ruleForm.value3 = this.gettopiccreationflag1014;
				if(this.getpasswordchange1014 == true)
				{           
					this.ruleForm.value4   = false;
				}
				else
				{
					this.ruleForm.value4   = true;
				}          
				this.ruleForm.value5   = this.getloginflag1014 ;       
				// 2026/06/15  生成AI連携商用版対応  START
				this.ruleForm.value6   = this.getaiserviceflag1014;
				this.initialAiServiceFlag = this.getaiserviceflag1014;
				// 2026/06/15  生成AI連携商用版対応  END       
				this.ruleForm.NikkiUserName = this.getscuserid1014;
				this.ruleForm.NikkiPassword= this.getscusepassword1014;
				//For the Mc user Authority
				var mcAuthority=this.getmcuser1014;
				var pushMC_id=[];
				var index_Mc='';
				for(var j=0;j<this.groupoptions.length;j++){
					pushMC_id.push(this.groupoptions[j].value);
				}
				index_Mc=pushMC_id.indexOf(mcAuthority);
				if(this.groupoptions[index_Mc] != undefined){
					if( this.is_MC_User_Authority == true){
						this.ruleForm.groupvalue = this.groupoptions[index_Mc].value;
					}else{
						this.ruleForm.groupvalue_nonreq = this.groupoptions[index_Mc].value;
					}
				}
				//For the Sc user Authority
				var ScAuthority=this.getscuser1014;
				var pushSc_id=[];
				var index_Sc='';
				for(var k=0;k<this.usageoptions.length;k++){
					pushSc_id.push(this.usageoptions[k].value);
				}
				index_Sc=pushSc_id.indexOf(ScAuthority);
				if(this.groupoptions[index_Sc] != undefined){
					if( this.is_SC_User_Authority == true){
						this.ruleForm.usagevalue=this.usageoptions[index_Sc].value;
					}else{
						this.ruleForm.usagevalue_nonreq=this.usageoptions[index_Sc].value;
					}
				}
				this.value1 = this.getvalue1;
				this.value2 = this.getvalue2;
				this.value3 = this.getvalue3;
				this.value4 = this.getvalue4;

				
			});

			

		}
	},
		mounted(){ 
			this.contract_id = this.getContractId
			this.user_id = this.getUserId
			// Get the dropdown details in page onload
			this.$store.dispatch('communication1014/getDropdownData');
			// 2026/06/15  生成AI連携商用版対応  START
			this.loadAiServiceUsageInfo();
			// 2026/06/15  生成AI連携商用版対応  END
			
			var service_linkage = this.getServiceLinkageInfo;
			var dataSection_arr=[];
			if(service_linkage != null)
			{
				for(var k=0; k<service_linkage.length; k++)
				{
					var data_section_linkage = service_linkage[k].data_section;
					if(data_section_linkage == "1"){
						this.is_MC_User_Authority = true;
					}

					if(data_section_linkage == "2"){
						this.is_SC_User_Authority = true;
					}
					dataSection_arr.push(data_section_linkage);
				}

			}
		},
	};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1014.css";
</style>
	
